import http from '../http';
import { PROJECT_API } from '@/config/env';

export const createProjectRegular = (prefix: string, project: FormData) => {
  return http.post(`${prefix}${PROJECT_API}/regular`, project, { returnFullResponse: true });
};

export const createProjectIndustry = (prefix: string, project: FormData) => {
  return http.post(`${prefix}${PROJECT_API}/industry`, project, { returnFullResponse: true });
};

export const updateProjectIndustry = (prefix: string, project: FormData) => {
  return http.put(`${prefix}${PROJECT_API}/industry`, project, { returnFullResponse: true });
};

export const updateProjectInfo = (id: string, project: FormData) =>
  http.put(`${PROJECT_API}/${id}/info`, project, { returnFullResponse: true });

export const getProjectByid = (prefix: string, id: string) =>
  http.get(`${prefix}${PROJECT_API}/${id}`, { returnFullResponse: true });
export const getProjectCreatingQuote = (prefix: string) =>
  http.get(`${prefix}${PROJECT_API}/status/creating-quote`, { returnFullResponse: true });

export const filterProject = (
  prefix: string,
  statuses: string[],
  query: string,
  companyId: number
) =>
  http.get(`${prefix}${PROJECT_API}/filter`, {
    params: companyId !== -1 ? { statuses, query, companyId } : { statuses, query },
    paramsSerializer: {
      indexes: null
    }
  });

export const delProjectById = (id: string) =>
  http.delete(`${PROJECT_API}/${id}`, { returnFullResponse: true });

export const registerQuote = (project: FormData) =>
  http.put(`${PROJECT_API}/register-quote`, project, { returnFullResponse: true });

export const returnContract = (request: any) =>
  http.put(`${PROJECT_API}/return-contract`, request, { returnFullResponse: true });

